import { Header } from '../components/Header';
import { BottomNav } from '../components/BottomNav';
import { useGuest } from '../lib/useGuest';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Index = () => {
  const { isGuest, loginAsGuest, clearGuest } = useGuest();
  const navigate = useNavigate();
  const [socialProof] = useState({
    photoCount: 1248,
    lastWinner: 'Emily from NYC',
  });

  const handleGuestEntry = () => {
    loginAsGuest();
    navigate('/challenge');
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-bauhaus-offwhite p-4">
      <div className="max-w-md w-full space-y-6">
        <div className="bg-bauhaus-green rounded-lg px-6 py-4 shadow-md text-bauhaus-offwhite flex flex-col items-center text-center">
          <h1 className="text-4xl font-bold font-['Bebas_Neue'] tracking-wide mb-1 drop-shadow-lg">Foto Fight</h1>
          <p className="mb-3 text-base font-medium text-bauhaus-offwhite/90">Daily A/B photo battles. Snap, vote, and rise to the top!</p>
          <div className="flex flex-row gap-3 justify-center items-center mb-2 flex-wrap">
            <span className="text-lg font-bold bg-white/10 px-3 py-1 rounded">{socialProof.photoCount} photos <span className="text-xs font-normal">this week</span></span>
            <span className="text-sm px-3 py-1 bg-bauhaus-darkgreen rounded-full shadow border border-white/10">Last winner: {socialProof.lastWinner}</span>
          </div>
        </div>
        <div className="bg-white/90 rounded-lg p-5 border text-center shadow border-bauhaus-green/20">
          <h2 className="font-semibold mb-2 text-bauhaus-green text-lg">How it works</h2>
          <ol className="list-decimal list-inside space-y-1 text-left text-bauhaus-green pl-3">
            <li>Pick your favorite challenge prompt.</li>
            <li>Snap or upload a photo that fits the theme.</li>
            <li>Vote in rapid-fire “this or that” showdowns.</li>
            <li>See if you win, collect badges, share the glory 🚀</li>
          </ol>
          <div className="mt-3 text-xs italic text-bauhaus-green/60">Try it out now — no signup needed!</div>
        </div>
        <button 
          className="w-full bg-bauhaus-green text-white font-semibold py-3 rounded-md shadow flex justify-center items-center transition-all hover:bg-bauhaus-darkgreen focus-visible:outline focus-visible:ring-2 focus-visible:ring-bauhaus-green aria-disabled:opacity-60"
          onClick={handleGuestEntry}>
          Enter as Guest (Vote &amp; Browse)
        </button>
        <button
          className="w-full bg-bauhaus-offwhite border-2 border-bauhaus-green text-bauhaus-green font-semibold py-2 rounded-md mt-2 hover:bg-bauhaus-green/10 focus-visible:outline focus-visible:ring-2 focus-visible:ring-bauhaus-green transition"
          onClick={() => {
            clearGuest();
            navigate('/auth');
          }}>
          Sign Up or Log In
        </button>
        <div className="mt-4 text-xs text-bauhaus-green/50">
          Invite friends to unlock bonus votes!
        </div>
      </div>
    </div>
  );
};

export default Index;
